import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

export default function GridContainer(props) {
  const { children, ...rest } = props;
  return (
    <Grid container {...rest}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node,
};
